import React, { useContext, useEffect, useState } from 'react'

//imagenes
import "@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css";
import usermng from "../../assets/img/user-mng.svg";
import { useParams } from 'react-router-dom';
import ConexContext from '../../context/ConexContext';
import { formatFecha } from '../JS/formato';

const PerfilEmpresa = () => {
	const { peticion, tipo_usuario, id_usuario } = useContext(ConexContext);
	const { empresa } = useParams();

	const [datosUsuCopy, setDatosUsuCopy] = useState(null); //datos del usuario copia
	const [datosUsu, setDatosUsu] = useState(null); //datos del usuario
	const [mensaje, setMensaje] = useState(null); //mensaje de error

	useEffect(() => {
		const datos_usuario = async () => {
			setMensaje(null);
			let res = await peticion(`/datos_empresa?entidad=${empresa.split('_')[0]}&empresa=${empresa.split('_')[1]}`, { method: 'GET' });
			if (res?.estado ?? true) return setMensaje('Se ha producido un error');
			if (res?.res ?? false) {
				setDatosUsu(res["res"]);
				setDatosUsuCopy(res["res"]);
			} else {
				setMensaje(res?.mensaje ?? 'Error al cargar los datos del usuario');
			}
		}
		//si el usuario es admin o es departamental quien consulta, carga los datos
		if (empresa && (((tipo_usuario === '5' || tipo_usuario === '2' || tipo_usuario === '3' || tipo_usuario === '0'))))
			datos_usuario();
		else //si no, muestra mensaje de error
			setMensaje('No tienes permisos para ver este usuario');
	}, [empresa, tipo_usuario, id_usuario, peticion]);

	const getDiferentes = (obj1, obj2) => {
		const diferentes = {};
		for (const key in obj2) {
			if (obj1[key] !== obj2[key]) {
				diferentes[key] = obj2[key];
			}
		}
		return diferentes;
	};

	const modUsu = async () => {
		let diferencias = getDiferentes(datosUsuCopy, datosUsu);
		if (Object.keys(diferencias).length === 0) return
		// Añadir campo entidad
		diferencias["entidad"]=empresa.split('_')[0]
		diferencias["empresa"]=empresa.split('_')[1]
		const res = await peticion(`/guardar_datos_empresa`, {
			method: 'POST', json: diferencias
		});
		if (res?.estado ?? true) return setMensaje('Se ha producido un error'); //error
		if (res?.mensaje !== 'OK' ?? false) return setMensaje(res?.mensaje ?? 'Error al cambiar la empresa '+empresa.split('_')[1]+''); //errores
		setDatosUsuCopy({ ...datosUsu });
	}

	return (
		<>
			<div className="col-xs-12 tabla" id='user-mng' >
				<div className='section-header'>
					<div className='img-container'>
						<img src={usermng} alt=''></img>
					</div>
					<div>
						<h2>Empresa</h2>
						<h6>
							{/* <strong>Listado</strong> /  */}
							{datosUsu?.cod_emp ?? ''}
						</h6>
					</div>
				</div>
				<main>
					{!datosUsu && !mensaje ? //si no hay datos ni mensaje, está cargando
						<h1 className="cargando">Cargando...</h1>
						: mensaje ? //si hay mensaje, muestra el mensaje (error)
							<h1 className="cargando">{mensaje}</h1>
							: //si hay datos, muestra los datos
							<>
								<form>
									<div className='form-item'>
										<label>Código de entidad</label>
										<input
											type='text'
											placeholder='Código de entidad'
											value={datosUsu?.cod_ent ?? ''}
											disabled={true}
											className="disabled"
										/>
									</div>
									<div className='form-item'>
										<label>Código de empresa</label>
										<input
											type='text'
											placeholder='Código de empresa'
											value={datosUsu?.cod_emp ?? ''}
											disabled={true}
											className="disabled"
										/>
									</div>
									<div className='form-item'>
										<label>Nombre de empresa</label>
										<input
											type='text'
											placeholder='Nombre de empresa'
											value={datosUsu?.nombre_emp ?? ''}
											disabled={(tipo_usuario !== '5' && tipo_usuario !== '2' && tipo_usuario !== '3' && tipo_usuario !== '0') ?? false}
											className={(tipo_usuario !== '5' && tipo_usuario !== '2' && tipo_usuario !== '3' && tipo_usuario !== '0') ? "disabled" : ""}
											onChange={(e) => setDatosUsu({ ...datosUsu, nombre_emp: e.target.value })}
										/>
									</div>
									<div className='form-item'>
										<label>Idioma</label>
										<input
											type='text'
											placeholder='Idioma'
											value={datosUsu?.idioma ?? ''}
											disabled={true}
											className="disabled"
										/>
									</div>
									<div className='form-item'>
										<label>Fecha de alta</label>
										<input
											type='text'
											placeholder='Fecha de carga'
											value={formatFecha(datosUsu.fecha_alta_emp.toString(), "ISO8601", "esp") ??  'No hay fecha de alta'}
											disabled={true}
											className="disabled"
										/>
									</div>
								</form>
								<div className='button-container'>
									<button className={(datosUsu && datosUsuCopy && (Object.keys(getDiferentes(datosUsuCopy, datosUsu)).length === 0))?('cta desactiva'):('cta')} onClick={() => modUsu()}>Guardar</button>
								</div>
							</>
					}
				</main>
			</div>
		</>
	)
}

export default PerfilEmpresa